import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';
    import FileUpload from '@/components/FileUpload.vue';

    interface Props {
        value: File;
        labelText: string;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'EditTHGCarVRCModal',
  props: {
    value: { default: undefined },
    labelText: { default: '' }
  },
  emits: ["input", "replace", "close"],
  setup(__props: any, { emit }: { emit: ({
        // eslint-disable-next-line no-unused-vars
        (e: 'input', value: File | undefined): void;
        (e: 'replace', value: File | undefined): void;
        (e: 'close'): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as { value: File, labelText: string };

    

    

    const file = computed<File | undefined>({
        get() {
            return props.value;
        },
        set(newVal: File | undefined) {
            emit('input', newVal);
        },
    });

    onMounted(() => {
        // clear the file when mounted
        file.value = undefined;
    });

return { __sfc: true,emit, props, file, FileUpload }
}

})